function validateForm(values) {
  let errors = {};

  return errors;
}

export default validateForm;
